import type { PropertyType } from '@/object-types/gql/PropertyType'
import type { PropertyValue } from './ObjectsService'
import { firstOrDefault } from '@/common/collection-utils'
import dayjs from 'dayjs'
import type { PropertyDefinitionModel } from '@/core/gql/gql-models-override.ts'

const constantInitialValues: [PropertyType, PropertyValue][] = [
  ['number', '42'],
  ['toggle', false],
]

export class CreateObjectService {
  private typeToInitialValues = new Map<PropertyType, PropertyValue>(constantInitialValues)

  public getInitialValue(propDef: PropertyDefinitionModel): PropertyValue {
    switch (propDef.type) {
      case 'date':
        return dayjs()
      case 'select-1': {
        const option = firstOrDefault(propDef.options!, undefined)
        return option?.id ?? 'Not set Id'
      }
      case 'multi-select': {
        return []
      }
      default:
        return this.typeToInitialValues.get(propDef.type)!
    }
  }
}
